import { Heading } from './ui';
import { LevelRules } from './LevelRules';
import { Preferences } from './Preferences';
import { ParallaxBg } from './ParallaxBg';
import './SetupScreen.css';

export function SetupScreen() {
  return (
    <div className="setup-screen">
      <ParallaxBg className="game-bg" />
      <div className="setup-content">
        <Heading className="setup-title">Game Setup</Heading>
        <div className="top-bar-settings-group">
          <LevelRules />
          <Preferences />
        </div>
      </div>
    </div>
  );
}
